import React from "react"

import GuestComplaintForm from "./GuestComplaintForm"

const App = (props) => <GuestComplaintForm {...props} />

export default App
